export const LOCAL_STORAGE_LANGUAGE_KEY = 'sandoog-language';
